/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_DescInputs */

const en_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your application activity over time.`)
};

const de_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Bewerbungsaktivität im Zeitverlauf.`)
};

const fr_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton activité de candidature au fil du temps.`)
};

const es_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su actividad de solicitud a lo largo del tiempo.`)
};

const it_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua attività di candidatura nel tempo.`)
};

const nl_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je sollicitatieactiviteit in de loop van de tijd.`)
};

const pl_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja aktywność aplikacyjna w czasie.`)
};

const fi_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemustoimintasi ajan mittaan.`)
};

const da_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din ansøgningsaktivitet over tid.`)
};

const sv_analytics_activity_desc = /** @type {(inputs: Analytics_Activity_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din ansökningsaktivitet över tid.`)
};

/**
* | output |
* | --- |
* | "Your application activity over time." |
*
* @param {Analytics_Activity_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_desc = /** @type {((inputs?: Analytics_Activity_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_desc(inputs)
	if (locale === "fr") return fr_analytics_activity_desc(inputs)
	if (locale === "es") return es_analytics_activity_desc(inputs)
	if (locale === "it") return it_analytics_activity_desc(inputs)
	if (locale === "nl") return nl_analytics_activity_desc(inputs)
	if (locale === "pl") return pl_analytics_activity_desc(inputs)
	if (locale === "fi") return fi_analytics_activity_desc(inputs)
	if (locale === "da") return da_analytics_activity_desc(inputs)
	if (locale === "sv") return sv_analytics_activity_desc(inputs)
	return en_analytics_activity_desc(inputs)
});